import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { TenderingBandwidthModel } from "../../models/TenderingBandwidthModel";
import TenderingBandwidthService from "../../services/TenderingBandwidthService";
import TenderingBandwidthSlice from "../slices/TenderingBandwidthSlice";
import { RootState } from "../store";

export const TenderingBandwidthActions = TenderingBandwidthSlice.actions;
export const fetchTenderingBandwidths = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(TenderingBandwidthActions.setIsTenderBandwidthsFetching(true));
    const response: TenderingBandwidthModel[] =
      await TenderingBandwidthService.getAllTenderingBandwidths();
    dispatch(TenderingBandwidthActions.setTenderingBandwidth(response));
    dispatch(TenderingBandwidthActions.setIsTenderBandwidthsFetching(false));
  };
};
export const fetchParticularTenderingBandwidth = (
  TenderingBandwidth_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: TenderingBandwidthModel =
      await TenderingBandwidthService.getParticularTenderingBandwidth(
        TenderingBandwidth_id
      );
    dispatch(
      TenderingBandwidthActions.setParticularTenderingBandwidth(response)
    );
  };
};
